import * as types from '@/store/types'
export default {
    products: state => {
        return state.products
    },
    productCategories: state => {
        return state.productCategories
    },
    productModelDef: state => {
        return state.productModelDef
    },
    getProductById: state => id => {
        return state.products.find(model => model.id === id)
    }
}
